module.exports = __webpack_public_path__ + "static/img/icon2-2.76a591f9.svg";